import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a9f8c4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "procenter" }
const _hoisted_2 = { class: "box wow animate__animated animate__backInDown" }

import SideMenu from './SideMenu.vue'
import NewSideMenu from './NewSideMenu.vue'
import Content from './Content.vue'
import { nextTick, onMounted, ref, watch } from 'vue'
import { useProIndexStore } from '@/store/index'
import ContactDialog from './ContactDialog.vue'
import {submitMessage} from '@/api/product'
import { ElMessage } from 'element-plus'
// import { useMenu } from s'./useMenu'
// const {
//     sub_menu_index,
//     openSubMenu
// } = useMenu();

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const index = ref('');
const sub_menu_index = ref(Number(useProIndexStore().proIndex));
const contactDialogVisible = ref(false);
const getSelectKey = (key: string) => {
    index.value = key;
    useProIndexStore().allIndex = key
};
const openSubMenu = (id: Number,menu_index:String) => {
    sub_menu_index.value = id
    index.value = menu_index
    useProIndexStore().proIndex = id
    useProIndexStore().allIndex = menu_index

};
const callForm = async (form) => {
    console.log(form);
    const response = await submitMessage(form);
    console.log(response);
    if (response.data.status === 'success') {
        ElMessage.success(response.data.msg);
        contactDialogVisible.value = false;
    }else{
        ElMessage.error(response.data.msg);
    }
};
// watch(
//     () => useProIndexStore().proIndex,
//     (val) => {
//         console.log('监听useProIndexStore().proIndex',val);
//         index.value = String(val);
//     },
//     {
//         immediate: true,
//         deep: true
//     }
// );


return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(NewSideMenu, {
          class: "side",
          onHandleSelect: getSelectKey,
          onOpenSubMenu: openSubMenu
        }),
        _createVNode(Content, {
          class: "right-content",
          menu_index: index.value,
          sub_menu_index: sub_menu_index.value
        }, null, 8, ["menu_index", "sub_menu_index"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: contactDialogVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((contactDialogVisible).value = $event)),
      title: "联系我们",
      width: "300"
    }, {
      default: _withCtx(() => [
        _createVNode(ContactDialog, {
          dialogVisible: contactDialogVisible.value,
          onSubmitForm: callForm
        }, null, 8, ["dialogVisible"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})